import { useActiveWeb3React } from "src/hooks"
import { useRarityRegistryContract } from "src/hooks/useContract"
import { useQuery } from "@tanstack/react-query"
import { BoostFarmQuery } from "src/constants/queryKeys"

const useNftRarity = (tokenId?: string | null) => {
  const rarityRegistryContract = useRarityRegistryContract()
  const { library } = useActiveWeb3React()
  return useQuery(
    [BoostFarmQuery.NFT_RARITY_BY_ID, tokenId],
    async () => {
      if (!tokenId || !rarityRegistryContract) return ""
      //cronos cruiser rarity 0 = common, 1 = rare, 2 = epic, 3 = legendary
      const rarity = await rarityRegistryContract.getRarityLevel(tokenId)
      switch (rarity.toNumber()) {
        case 3:
          return "Legendary"
        case 2:
          return "Epic"
        case 1:
          return "Rare"
        case 0:
        default:
          return "Common"
      }
    },
    {
      enabled: !!library,
      staleTime: 1000 * 60 * 30,
      cacheTime: 1000 * 60 * 60,
    },
  )
}

export default useNftRarity
